/** 진단 리포트 버전. `v1` = 개편 전(정오답표 + 수학머리 2쪽), `v2` = 개편 후(영역 카드 + 수학머리 능력별 4쪽). */
export type DiagnosticReportVersion = 'v1' | 'v2'

/**
 * `?version=` 없이 열었을 때 보이는 기본 리포트. 서버가 만드는 PDF도 이 버전으로 그린다.
 * 기본이 아닌 버전은 `?version=`으로 계속 볼 수 있다.
 */
export const DEFAULT_DIAGNOSTIC_REPORT_VERSION: DiagnosticReportVersion = 'v2'

/** URL `?version=` 값을 읽는다. `v1`·`v2`가 아니면(없음·오타 포함) 기본 리포트. */
export function parseDiagnosticReportVersion(value: string | null | undefined): DiagnosticReportVersion {
  return value === 'v1' || value === 'v2' ? value : DEFAULT_DIAGNOSTIC_REPORT_VERSION
}
